import DimensionResolver from '@/composables/charts/influx-charts/dimension-resolvers/DimensionResolver.js'
import i18n from '@/plugins/i18n.js'
import { useInstanceStore } from '@/store/backendInstances.js'
const { t, te } = i18n.global

/**
 * Resolver for Detection-Labels. Matches the tag key "label" and returns a human readable variant of the given Label.
 * Checks whether a translation is available under 'measurements.labels.[LABEL]' and uses that, otherwise returns the
 * provided label
 */
class LabelDimensionResolver extends DimensionResolver {
  async doesTagKeyMatch(tag) {
    return tag === 'label'
  }

  async humanizeTagValue(tagValue) {
    if (te('measurements.labels.' + tagValue)) return t('measurements.labels.' + tagValue)
    return tagValue
  }
  static isRelevantForCurrentInstance() {
    return useInstanceStore().selectedInstance.instanceType === 'barn'
  }
}

export default LabelDimensionResolver
